<section>
  <h2>User Profile</h2>
  <div class="alert alert-info" role="alert" *ngIf="!viewMode && ownProfile">
    <p *ngIf="showATFHelpText">
      <strong>User type:</strong> Select the correct user type (ATF Employees & <strong>TFOs</strong> select ATF Field Division or ATF HQ, as appropriate)
    </p>
    <p><strong>User role:</strong> Select the appropriate role from the dropdown</p>
    <ul class="list-unstyled ps-3">
      <li>Viewer: Read Only</li>
      <li>Editor: Read/Write</li>
      <li *ngIf="!showStateLocalHelpText">Power User: Read/Write/All Exports/Bulk RMS Data Import/Manage Data</li>
      <li>Application Administrator: Read/Write/All Exports/Bulk RMS Data Import/Manage Data/Manage Users</li>
    </ul>
    <p>Contact your Field Division POC or <a href="mailto:ness_support@atf.gov?subject=NESS Account Profile support request">NESS_Support&#64;atf.gov</a> if you have questions or need assistance.</p>
  </div>
  <form class="mb-3" [class.w-md-50]="ownProfile" [formGroup]="userProfileForm">
    <button type="button" class="btn btn-active mb-3" (click)="toggleEditMode()" *cdsApproverProfile="{userProfileOwner: userInfoForOtherUser}">{{ viewMode ? 'Edit' : 'View' }} {{ ownProfile ? "profile" : "user info" }}</button>
    <p class="fw-bold font-size-sm" *ngIf="ownProfile && isCDSApprover()">
      You are a CDS Approver. You cannot edit your user profile. Contact <a href="mailto:ness_support@atf.gov">NESS_Support&#64;atf.gov</a> for assistance.
    </p>
    <p class="fw-bold font-size-sm" *ngIf="!ownProfile && isCDSApprover() && !isNESSAdmin()">
      This user is a CDS Approver.  You cannot edit this user's profile. Contact <a href="mailto:ness_support@atf.gov">NESS_Support&#64;atf.gov</a> for assistance.
    </p>
    <p class="fw-bold font-size-sm" *ngIf="!ownProfile && isCDSApprover() && isNESSAdmin()">
      This user is a CDS Approver. You cannot edit selected user's profile information. Contact <a href="mailto:ness_support@atf.gov">NESS_Support&#64;atf.gov</a> for assistance.
    </p>
    <p-messages key="userInfoMsg" [closable]="true" (valueChange)="onMessageClose($event)"></p-messages>
    <div class="row g-sm-2">
      <label for="Email" class="col-form-label col-sm-4 col-md-3 text-sm-end">Email address:</label>
      <div class="col-sm-8 col-md-9">
        <input type="text" readonly aria-readonly="true" formControlName="Email" class="form-control form-control-plaintext" id="Email" />
      </div>
      <label for="FirstName" class="col-form-label col-sm-4 col-md-3 text-sm-end" [class.required-field]="ownProfile">First name:</label>
      <div class="col-sm-8 col-md-9 ">
        <input type="text" [attr.readonly]="viewMode || !ownProfile" [attr.aria-readonly]="viewMode || !ownProfile" formControlName="FirstName" [class.form-control]="!viewMode" [class.form-control-plaintext]="viewMode" id="FirstName" [attr.required]="ownProfile" [attr.aria-required]="ownProfile" />
        <div class="invalid-feedback">
          Please enter your first name.
        </div>
      </div>
      <label for="LastName" class="col-form-label col-sm-4 col-md-3 text-sm-end" [class.required-field]="ownProfile">Last name:</label>
      <div class="col-sm-8 col-md-9">
        <input type="text" [attr.readonly]="viewMode || !ownProfile" [attr.aria-readonly]="viewMode || !ownProfile" formControlName="LastName" [class.form-control]="!viewMode" [class.form-control-plaintext]="viewMode" id="LastName" />
        <div class="invalid-feedback">
          Please enter your last name.
        </div>
      </div>
      <label for="PhoneNumber" class="col-form-label col-sm-4 col-md-3 text-sm-end">Phone number:</label>
      <div class="col-sm-8 col-md-9">
        <ng-container *ngIf="viewMode;else phinput">
          <input type="text" id="PhoneNumber" class="form-control-plaintext" value="{{ ownProfile ? userInfo?.PhoneNumber : userInfoForOtherUser?.PhoneNumber }}" readonly aria-readonly="true" />
        </ng-container>
        <ng-template #phinput>
          <p-inputMask type="text" mask="(999) 999-9999" formControlName="PhoneNumber" styleClass="form-control" inputId="PhoneNumber"></p-inputMask>
        </ng-template>
      </div>
      <label for="UserType" class="col-form-label col-sm-4 col-md-3 text-sm-end"><span [class.required-field]="ownProfile">User type:</span> <small [class.d-block]="ownProfile" class="text-danger" *ngIf="ownProfile">(Requires approval)</small></label>
      <div class="col-sm-8 col-md-9">
        <ng-container *ngIf="viewMode;else userTypeSelect">
          <input id="UserType" type="text" class="form-control-plaintext" value="{{ ownProfile ? userInfo?.UserTypeDisplay : userInfoForOtherUser?.UserTypeDisplay }}" readonly aria-readonly="true" />
        </ng-container>
        <ng-template #userTypeSelect>
          <select #userTypeSelectEl id="UserType" class="form-select" formControlName="UserTypeID" (change)="onSelectUserType(userTypeSelectEl.value)" [attr.required]="ownProfile" [attr.aria-required]="ownProfile">
            <option value="">Select a user type</option>
            <option *ngFor="let userType of userTypes" value="{{userType.Id}}">{{userType.UserTypeDsiaplyName}}</option>
          </select>
          <div class="invalid-feedback">
            Please provide the user type.
          </div>
        </ng-template>
      </div>
      <label for="JobTitleID" class="col-form-label col-sm-4 col-md-3 text-sm-end" [class.required-field]="ownProfile">Job title:</label>
      <div class="col-sm-8 col-md-9">
        <ng-container *ngIf="viewMode;else jobTitleSelect">
          <input type="text" id="JobTitleID" class="form-control-plaintext" value="{{ UserJobTitle }}" readonly aria-readonly="true" />
        </ng-container>
        <ng-template #jobTitleSelect>
          <select #jobTitleSelectEl id="JobTitleID" class="form-select" formControlName="JobTitleID" (change)="onSelectJobTitle(jobTitleSelectEl.value)" [attr.required]="ownProfile" [attr.aria-required]="ownProfile">
            <option value="">Select a job title</option>
            <option *ngFor="let jobTitle of filteredJobTitles" value="{{jobTitle.ID}}">{{jobTitle.JobTitle}} ({{jobTitle.Abbreviation}})</option>
          </select>
          <div class="invalid-feedback">
            Please provide the job title.
          </div>
        </ng-template>
      </div>
      <ng-container *ngIf="!viewMode && showOtherJobTitle">
        <label for="OtherJobTitle" class="col-form-label col-sm-4 col-md-3 text-sm-end"><span [class.required-field]="ownProfile">Other:</span> <span class="d-block">(100 chars max)</span></label>
        <div class="col-sm-8 col-md-9">
          <input type="text" formControlName="OtherJobTitle" class="form-control" id="OtherJobTitle" maxlength="100" [attr.required]="ownProfile" [attr.aria-required]="ownProfile" />
          <div class="invalid-feedback">
            Please enter other job title.
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="showFieldDivision">
        <label for="FieldDivisionID" class="col-form-label col-sm-4 col-md-3 text-sm-end"><span [class.required-field]="ownProfile">ATF Field Division:</span><small class="text-danger" [class.d-block]="ownProfile" *ngIf="ownProfile">(Requires approval)</small></label>
        <div class="col-sm-8 col-md-9">
          <ng-container *ngIf="viewMode;else fieldDivisionSelect">
            <input id="FieldDivisionID" type="text" class="form-control-plaintext" value="{{ ownProfile ? userInfo?.FieldDivisionName : userInfoForOtherUser?.FieldDivisionName }}" readonly aria-readonly="true" />
          </ng-container>
          <ng-template #fieldDivisionSelect>
            <select #fieldDivisionSelectEl id="FieldDivisionID" formControlName="FieldDivisionID" class="form-select" (change)="onSelectFieldDivision(fieldDivisionSelectEl.value)" [attr.required]="ownProfile" [attr.aria-required]="ownProfile">
              <option value="">Select a field division</option>
              <option *ngFor="let fieldDiv of fieldDivisions$ | async" value="{{fieldDiv.FieldDivisionID}}">{{fieldDiv.FieldDivisionName}}</option>
            </select>
          </ng-template>
        </div>
        <label for="FieldDivisionGroupID" class="col-form-label col-sm-4 col-md-3  text-sm-end"><span [class.required-field]="ownProfile">Group:</span><small class="text-danger" [class.d-block]="ownProfile" *ngIf="ownProfile">(Requires approval)</small></label>
        <div class="col-sm-8 col-md-9 ">
          <ng-container *ngIf="viewMode;else fdGroupSelect">
            <input id="FieldDivisionGroupID" type="text" class="form-control-plaintext" value="{{ ownProfile ? userInfo?.FieldDivisionGroup + ' ('+ (userInfo?.FieldDivisionGroupStatus  | booleanTransform: 'Inactive' : 'Active') +')' : userInfoForOtherUser?.FieldDivisionGroup + ' ('+ (userInfoForOtherUser?.FieldDivisionGroupStatus | booleanTransform: 'Inactive' : 'Active') + ')' }}" readonly aria-readonly="true" />
          </ng-container>
          <ng-template #fdGroupSelect>
            <select id="FieldDivisionGroupID" formControlName="FieldDivisionGroupID" class="form-select" [attr.required]="ownProfile" [attr.aria-required]="ownProfile">
              <option value="">Select a group</option>
              <option *ngFor="let fdGroup of filteredFDGroup" value="{{fdGroup.IntelligenceReportATFReferralGroupsID}}" [class.text-muted]="fdGroup.Inactive" [disabled]="fdGroup.Inactive">{{fdGroup.GroupName}} ({{fdGroup.Inactive | booleanTransform: 'Inactive' :'Active'}})</option>
            </select>
            <div class="invalid-feedback">
              Please provide the group.
            </div>
          </ng-template>
        </div>
      </ng-container>
      <ng-container *ngIf="showAgency">
        <label for="StateID" class="col-form-label col-sm-4 col-md-3 text-sm-end"><span [class.required-field]="ownProfile">Agency state:</span><small class="text-danger" [class.d-block]="ownProfile" *ngIf="ownProfile">(Requires approval)</small></label>
        <div class="col-sm-8 col-md-9">
          <ng-container *ngIf="viewMode;else stateSelect">
            <input id="StateID" type="text" class="form-control-plaintext" value="{{ ownProfile ? userInfo?.AgencyStateName : userInfoForOtherUser?.AgencyStateName }}" readonly aria-readonly="true" />
          </ng-container>
          <ng-template #stateSelect>
            <select #stateSelectEl id="StateID" class="form-select" formControlName="StateID" (change)="onSelectState(stateSelectEl.value)" [attr.required]="ownProfile" [attr.aria-required]="ownProfile">
              <option value="">Select state</option>
              <ng-container *ngIf="lookupService.usStates$ | async as usStates">
                <option *ngFor="let state of usStates" value="{{state.StateID.toUpperCase()}}">{{state.StateName}}</option>
              </ng-container>
            </select>
            <div class="invalid-feedback">
              Please provide the agency state.
            </div>
          </ng-template>
        </div>
        <label for="AgencyID" class="col-form-label col-sm-4 col-md-3 text-sm-end"><span [class.required-field]="ownProfile">Agency:</span><small class="text-danger" [class.d-block]="ownProfile" *ngIf="ownProfile">(Requires approval)</small></label>
        <div class="col-sm-8 col-md-9">
          <ng-container *ngIf="viewMode;else agencySelect">
            <input id="AgencyID" class="form-control-plaintext" value="{{ ownProfile ? userInfo?.AgencyName : userInfoForOtherUser?.AgencyName }}" readonly aria-readonly="true" />
          </ng-container>
          <ng-template #agencySelect>
            <select id="AgencyID" class="form-select" formControlName="AgencyID" [attr.required]="ownProfile" [attr.aria-required]="ownProfile">
              <option value="">Select agency</option>
              <option *ngFor="let agency of filteredAgencies" value="{{agency.AgencyID.toUpperCase()}}">{{agency.AgencyName}}</option>
            </select>
            <div class="invalid-feedback">
              Please provide the agency.
            </div>
          </ng-template>
        </div>
      </ng-container>
      <ng-container formArrayName="Roles" *ngFor="let item of Roles.controls;let i = index">
        <ng-container [formGroupName]="i">
          <label for="RoleID{{i}}" class="col-form-label col-sm-4 col-md-3 text-sm-end"><span [class.required-field]="ownProfile">User role:</span><small class="text-danger" [class.d-block]="ownProfile" *ngIf="ownProfile">(Requires approval)</small></label>
          <div class="col-sm-8 col-md-9">
            <ng-container *ngIf="viewMode;else roleSelect">
              <input id="RoleID{{i}}" type="text" class="form-control-plaintext" value="{{roleName}}" readonly aria-readonly="true" />
            </ng-container>
            <ng-template #roleSelect>
              <select id="RoleID{{i}}" class="form-select" formControlName="Id" [attr.required]="ownProfile" [attr.aria-required]="ownProfile">
                <option value="">Select a user role</option>
                <option *ngFor="let role of filteredRoles" value="{{role.Id}}">{{role.Name}}</option>
              </select>
              <div class="invalid-feedback">
                Please provide the user role.
              </div>
            </ng-template>
          </div>
        </ng-container>
      </ng-container>
      <div class="mt-3 offset-sm-4 offset-md-3 col-sm-8 col-md-9">
        <button type="button" [disabled]="!userProfileForm.valid || viewMode" (click)="onSubmit()" class="btn btn-active mb-2">Submit</button>
        <button type="button" [disabled]="viewMode" class="btn btn-secondary mb-2" (click)="onCancel()">Cancel</button>
      </div>
    </div>
  </form>
</section>
<p-dialog header="User profile change comment" [(visible)]="showUserCommentsForm" [draggable]="false" [modal]="true" [resizable]="true" [baseZIndex]="10000" styleClass="deleteDialog" appendTo="body" ariaCloseLabel="Close the user profile change comment dialog box" [style]="{width: '50vw'}" [breakpoints]="{'992px': '75vw', '576px': '90vw'}">
  <form [formGroup]="userHistoryForm">
    <div class="mb-3">
      <label for="Comments" class="form-label required-field">
        Explain the change made and the reason for the change. (Maximum 200 characters)
      </label>
      <p>Example: Changed user's role from Application Administrator to Editor. User no longer needs Application Administrator access.</p>
      <textarea [rows]="textAreaRows" #comments id="Comments" class="form-control" formControlName="Comments" maxlength="200"></textarea>
      <div class="invalid-feedback">
        Please provide comments.
      </div>
    </div>
    <div>
      <button type="button" class="btn btn-active mb-2" [disabled]="userHistoryForm.invalid" (click)="onUserHistorySubmitted()" value="Submit">Submit</button>
      <button type="button" class="btn btn-secondary mb-2" (click)="onCloseUserHistoryForm()" value="Cancel">Cancel</button>
    </div>
  </form>
</p-dialog>
